

















































































































































































































































































































































import { apiClient } from "@/services/api-client";
import { mapGetters, mapState } from "vuex";
import DetailsBesteltips from "../components/Details/DetailsBesteltips.vue";
import DetailsMeegeleverdeArtikelen from "../components/Details/DetailsMeegeleverdeArtikelen.vue";
import DetailsInformation from "../components/Details/DetailsInformation.vue";
import LoadingBlock from "../components/LoadingBlock.vue";
import CategoryBreadCrumbs from "@/components/CategoryBreadCrumbs.vue";
import DetailsDocuments from "@/components/Details/DetailsDocuments.vue";
import TheBannerSmall from "@/components/The/TheBannerSmall.vue";
import FavorietToevoegen from "@/components/FavorietToevoegen.vue";
import BasePage from "@/components/Base/BasePage.vue";
import { publicCheckMixin } from "@/mixins/publicCheckMixin";
import BaseResponsiveTable from "@/components/Base/BaseResponsiveTable.vue";
import BaseIconAlert from "@/components/Base/BaseIconAlert.vue";
import ImageDisplay from "@/components/ImageDisplay.vue";
import InputAmount from "@/components/InputAmount.vue";
import { MaterieelVerkoopType } from "@/services/api-client-generated";
import TheLaatstBekeken from "@/components/The/TheLaatstBekeken.vue";
import { logPageMixin } from "@/mixins/LogPageMixin";
import { detectUriTextMixin } from "@/mixins/detectUriTextMixin";
import { getTranslationMixin } from "@/mixins/getTranslationMixin";
import { i18n } from "@/plugins/i18n";
import { errorHandlingApiResponse } from "@/mixins/errorHandlingApiResponse";
import BaseInfoTooltip from "@/components/Base/BaseInfoTooltip.vue";
import BestellijstenToevoegen from "@/components/BestellijstenToevoegen.vue";
import CurrencyFormat from "@/components/CurrencyFormat.vue";

export default {
  name: "Details",
  components: {
    TheLaatstBekeken,
    InputAmount,
    ImageDisplay,
    BaseIconAlert,
    BaseResponsiveTable,
    BasePage,
    FavorietToevoegen,
    TheBannerSmall,
    DetailsDocuments,
    CategoryBreadCrumbs,
    LoadingBlock,
    DetailsInformation,
    DetailsMeegeleverdeArtikelen,
    DetailsBesteltips,
    BaseInfoTooltip,
    BestellijstenToevoegen,
    CurrencyFormat
  },
  mixins: [
    publicCheckMixin,
    logPageMixin,
    detectUriTextMixin,
    getTranslationMixin,
    errorHandlingApiResponse
  ],
  data() {
    return {
      details: {
        aanvullendeInformatieLijst: [],
        aanvullendeInformatieLijstVertalingen: [],
        imageUrls: [],
        tekstueleInformatieLijst: []
      },
      meegeleverdeArtiekelen: [],
      bestelTips: [],
      isDetailsLoading: false,
      isMeegeleverdeArtiekelenLoading: false,
      isBestelTipsLoading: false,
      isNotFound: false,
      VUE_APP_BACKEND_URI: process.env.VUE_APP_BACKEND_URI,
      MaterieelVerkoopType,
      nextItemIndex: -1,
      previousItemIndex: -1
    };
  },
  computed: {
    ...mapGetters([
      "selectedLocationId",
      "currentCategories",
      "getBoolSetting",
      "getIntSetting",
      "isAuthenticated",
      "getMultiSetting",
      "selectedLocationReadOnly"
    ]),
    ...mapState({
      itemIds: (state: any) => state.filter.itemIds
    }),
    hasLocation() {
      return this.$store.getters.selectedLocationId !== null;
    },
    hasLocationOrReadonly() {
      if (this.hasLocation) {
        return !this.$store.getters.selectedLocationReadOnly;
      } else {
        return false;
      }
    },
    readOnly() {
      if (this.hasLocation) {
        if (this.$store.getters.selectedLocationReadOnly) {
          return false;
        } else {
          return this.canOrder;
        }
      } else {
        return false;
      }
    },
    showPriceInfo() {
      return this.$store.getters.showPrice;
    },
    showMeegeleverd() {
      return this.getBoolSetting(
        "Catalogus_MeegeleverdeArtikelen_TonenEnGebruiken"
      );
    },
    showDetailsMelding() {
      return this.getBoolSetting(
        "Details_ToonTechnischeGegevensAanwezigMelding"
      );
    },

    useBestellijsten() {
      return this.getBoolSetting("Bestellen_EnableMeerdereBestellijsten");
    },

    showTechnischeGegevens() {
      var loggedInRequired = this.getBoolSetting(
        "Details_ToonTechnischeGegevensIngelogd"
      );
      var isLoggedIn = this.$store.getters.isAuthenticated;

      if (loggedInRequired && !isLoggedIn) {
        return false;
      }
      return true;
    },
    GetAanvullendeInformatie() {
      var data = [];

      if (
        this.details.aanvullendeInformatieLijstVertalingen &&
        this.details.aanvullendeInformatieLijstVertalingen.hasOwnProperty(
          i18n.locale
        )
      ) {
        return this.details.aanvullendeInformatieLijstVertalingen[i18n.locale];
      } else {
        return this.details.aanvullendeInformatieLijst;
      }

      return this.details.aanvullendeInformatieLijst;
    },
    showBesteltips() {
      return this.getBoolSetting("Details_ToonBesteltips");
    },

    showDayPrice() {
      return this.getMultiSetting("Materieel_ShowDayPrice");
    },
    showWeekPrice() {
      return this.getMultiSetting("Materieel_ShowWeekPrice");
    },
    showDetailsInformation() {
      return (
        (!this.details.tekstueleInformatieLijst.isEmpty() ||
          (this.details.afbeeldingInformatieLijst &&
            !this.details.afbeeldingInformatieLijst.isEmpty())) &&
        this.showTechnischeGegevens
      );
    },
    canOrder() {
      return this.details.aantal > 0;
    },

    getItems() {
      let items = [
        {
          ...this.details
        },
        ...this.bestelTips
      ];

      let hasMeegeleverd = false;

      if (this.showMeegeleverd) {
        items = [
          ...items,
          ...this.meegeleverdeArtiekelen.map(x => {
            return {
              ...x,
              parentNummer: this.details.materieelSoort,
              parentType: this.details.type
            };
          })
        ];

        hasMeegeleverd =
          this.meegeleverdeArtiekelen.filter(a => a.aantal).length > 0;
      }

      items = items.filter(a => a.aantal);

      if (items.length === 0) {
        return;
      }

      return items.map(a => {
        return {
          materieelSoort: a.materieelSoort,
          type: a.type,
          aantal: a.aantal,
          parentNummer: a.parentNummer,
          parentType: a.parentType
        };
      });
    }
  },
  created() {
    this.$store.dispatch("categoriesInitialized");
    this.fetchData(this.$route.params.id);
  },
  methods: {
    showAantal() {
      if (this.selectedLocationId) {
        return true;
      } else {
        return false;
      }
    },
    getTranslationsAanvullendeInformatie(aanvullendeInformatie) {
      var tekst = aanvullendeInformatie;
      if (
        aanvullendeInformatie.translations &&
        aanvullendeInformatie.translations.hasOwnProperty(i18n.locale)
      ) {
        tekst = aanvullendeInformatie.translations[i18n.locale];
      } else {
        tekst = aanvullendeInformatie.text;
      }

      return tekst;
    },
    setMeegeleverdeArtikelen() {
      for (const artikel of this.meegeleverdeArtiekelen) {
        artikel.aantal = artikel.aanbevolenHoeveelheid * this.details.aantal;
      }
    },

    addItems() {
      let items = [
        {
          ...this.details
        },
        ...this.bestelTips
      ];

      let hasMeegeleverd = false;

      if (this.showMeegeleverd) {
        items = [
          ...items,
          ...this.meegeleverdeArtiekelen.map(x => {
            return {
              ...x,
              parentNummer: this.details.materieelSoort,
              parentType: this.details.type
            };
          })
        ];

        hasMeegeleverd =
          this.meegeleverdeArtiekelen.filter(a => a.aantal).length > 0;
      }

      items = items.filter(a => a.aantal);

      if (items.length === 0) {
        return;
      }

      apiClient
        .addAllDetailsBestelLijst({
          gebruikerLogin: this.$store.state.auth.username,
          materieellocatie: this.selectedLocationId,
          bestelListItems: items.map(a => {
            return {
              materieelSoort: a.materieelSoort,
              type: a.type,
              aantal: a.aantal,
              parentNummer: a.parentNummer,
              parentType: a.parentType
            };
          })
        })
        .then(() => {
          return this.$store.dispatch("bestellijstRequested");
        })
        .then(() => {
          this.$store.dispatch("snackbarAdded", {
            text: this.$t("Details.toevoegen_bestellijst_succes"),
            type: "success"
          });

          if (hasMeegeleverd) {
            this.$store.dispatch("snackbarAdded", {
              text: this.$t("Catalogus.message_meegeleverd"),
              type: "success"
            });
          }
        })
        .catch(error => {
          errorHandlingApiResponse.methods.getSnackbarText(error.status);
        })
        .finally(() => {
          this.resetAantallen();
        });
    },
    resetAantallen() {
      this.details.aantal = null;
      for (const item of this.meegeleverdeArtiekelen) {
        item.aantal = item.aanbevolenHoeveelheid;
      }
      for (const item of this.bestelTips) {
        item.aantal = null;
      }
    },
    fetchData(materieelsoort) {
      this.isDetailsLoading = true;
      this.isMeegeleverdeArtiekelenLoading = true;
      this.isBestelTipsLoading = true;

      apiClient
        .getMaterieelDetails({
          materieellocatie: this.selectedLocationId,
          materieelsoort
        })
        .then(response => response.detail)
        .then(detail => {
          this.$store.dispatch("laatstBekekenToegevoegd", detail);

          return {
            ...detail,
            aantal: 1
          };
        })
        .then(detail => {
          this.details = detail;
          this.isDetailsLoading = false;
          this.setNextItemIdIndex(detail.materieelSoort);
          this.setPreviousItemIdIndex(detail.materieelSoort);
        })
        .catch(err => {
          if (err.status === 404) {
            this.isNotFound = true;
            return;
          }

          this.$store.dispatch("snackbarAdded", {
            text: this.$t("Details.error_besteltips"),
            type: "danger"
          });
        });

      apiClient
        .getMeegeLeverdeItems({
          materieelLocatie: this.selectedLocationId,
          materieelSoort: materieelsoort
        })
        .then(response =>
          response.artikelen.map(a => {
            return { ...a, aantal: a.aanbevolenHoeveelheid };
          })
        )
        .then(response => {
          this.meegeleverdeArtiekelen = response;
          this.isMeegeleverdeArtiekelenLoading = false;
        })
        .catch(err => {
          if (err.status === 400) {
            return;
          }

          this.$store.dispatch("snackbarAdded", {
            text: this.$t("Details.error_artikelen"),
            type: "danger"
          });
        });

      apiClient
        .getMaterieelBestelTips({
          materieelLocatie: this.selectedLocationId,
          materieelSoort: materieelsoort
        })
        .then(response => {
          this.bestelTips = response.bestelTips;
          this.isBestelTipsLoading = false;
        })
        .catch(err => {
          if (err.status === 400) {
            return;
          }
          this.$store.dispatch("snackbarAdded", {
            text: this.$t("Details.error_besteltips"),
            type: "danger"
          });
        });
    },
    setNextItemIdIndex(currentItemId: string) {
      const itemIds = this.itemIds;
      const currentItemIdIndex = itemIds.indexOf(currentItemId);
      if (currentItemIdIndex >= 0 && currentItemIdIndex < itemIds.length - 1) {
        this.nextItemIndex = currentItemIdIndex + 1;
      }
    },
    setPreviousItemIdIndex(currentItemId: string) {
      const itemIds = this.itemIds;
      const currentItemIdIndex = itemIds.indexOf(currentItemId);
      if (currentItemIdIndex > 0 && currentItemIdIndex <= itemIds.length - 1) {
        this.previousItemIndex = currentItemIdIndex - 1;
      }
    },
    navigateToItem(itemIndex: number) {
      const itemId = this.itemIds[itemIndex];
      this.$router.push(`/details/${itemId}`);
      this.nextItemIndex = -1;
      this.previousItemIndex = -1;
    }
  },

  beforeRouteUpdate(to, from, next) {
    this.fetchData(to.params.id);
    next();
  }
};
